import Project from './Project';

const projectsData = [
    {
        name: 'LOL Match Analyzer',
        description: 'A full-stack League of Legends match analysis app that takes a Riot ID, fetches recent matches, and generates a player-focused analysis for a selected match using an LLM.',
        techStack: ['React', 'TypeScript', 'Node.js', 'Express', 'MongoDB', 'Groq AI', 'Jest'],
        githubUrl: 'https://github.com/andychokim/LOL-Match-Analyzer',
        liveUrl: 'https://lolma.andrewkims.work'
    }
];

const Projects = () => {
    return (
        <section className="projects-section">
            <h2 className="section-title">Selected Projects</h2>
            <div className="projects-grid">
                {projectsData.map((project, i) => (
                    <Project key={i} {...project} />
                ))}
            </div>
        </section>
    );
};

export default Projects;